import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import Dialog from '@material-ui/core/Dialog';

/* React Router */
import { withRouter } from 'react-router-dom'

/* Routes */
import { domainIsTenant as dit, S, domain } from '../../../../../routes/routes'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../../../redux/ducks'
import { actions as notificationActions } from '../../../../../redux/ducks/notification'

/* Object Json */
import { safeDeepGetWithType, parse, stringify, safeDeepGet, clean, stringifyFormatted } from 'iotera-base/json';
import { isEmpty, isNone } from 'iotera-base/object';

// function
import { Transition } from '../function'

import { IoteraForm } from '../../../../../lib/components/form';
import { SubViewHeader } from '../../../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { AreaInput, TextInput } from '../../../../../lib/components/textInput';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../../../lib/components/callbackGlobal';
import Result from 'iotera-base/result';

const EDIT_POLICY = 'EDIT_POLICY';
const WKEY = 'POLICY';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function schema() {
  return {
    type: "object",
    required: ["policy"],
    properties: {
      policy: { type: "string", title: "Policy" },
    }
  }
};

const uiSchema = {
  policy: {
    "ui:widget": (props) => {
      return (
        <AreaInput
          id="policy"
          type="text"
          label="Add Policy"
          textTooltip="Add Policy"
          value={props.value}
          required={props.required}
          onChange={event => props.onChange(event.target.value)}
          areaHeight={200}
          {...props}
        />
      )
    },
    "ui:options": {
      label: false
    }
  }
};

class Policy extends Component {
  constructor(props) {
    super(props);
    const deviceId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      deviceId,
      loading: false,
      formData: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { deviceId } = _state;
    if (isNone(deviceId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    const sensorKey = safeDeepGet(this, ['props', 'selected', 'key']);

    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: {
          ...domainIsTenant, path: '/service/web/device/sensor/get', params: {
            device_id: deviceId,
            key: sensorKey
          }
        },
        wcallback: {
          started: function (id) {
          }
        },
        wreducer: {
          rparse: function (id, rparse, rpayload) {
            const item = {};
            item.policy = stringify(safeDeepGetWithType(rpayload, ['policies'], {}));
            clean(item)
            _this.setState({ loading: false })
            return item;
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT_POLICY]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/device/sensor/edit"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({ loading: false })
                  _props.showSingleNotification({ message: 'Edit policy sukses', level: 'success' });
                  // close slide modal
                  _props.handleClose()
                  return;
                }
              }
              _this.setState({ loading: false })
              _props.showSingleNotification({ message: 'Edit policy gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { deviceId } = _state;
    if (isNone(deviceId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleChange(event) {
    this.setState({ formData: event.formData })
  }

  handleExpandNode = () => false

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { deviceId } = _state;
    if (isEmpty(deviceId)) {
      return;
    }
    const sensorKey = safeDeepGet(this, ['props', 'selected', 'key']);
    const submitData = safeDeepGet(_state, ['formData'])
    const policy = safeDeepGetWithType(submitData, ['policy'], '');
    const policy_object = parse(policy)
    if (isNone(policy_object)) {
      submitData['policy'] = stringify(policy_object)
      _props.showSingleNotification({ message: 'Policy harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: submitData })
      return;
    }

    submitData['policy'] = stringifyFormatted(policy_object)
    _this.setState({ formData: submitData })
    const policyBody = {
      policies: policy_object,
      device_id: deviceId,
      key: sensorKey
    }
    clean(policyBody);
    _this.setState({ loading: true });
    _props.wSingleRequestCall({
      id: EDIT_POLICY,
      body: policyBody
    });
  }

  render() {
    const _this = this
    const _props = _this.props
    const { dialogPolicy, handleClose } = _props
    const _state = _this.state
    const { formData, loading } = _state
    let dataToShow = null
    const item = safeDeepGet(_props, ['item'], {});
    if (!isEmpty(formData)) {
      dataToShow = formData
    }
    else {
      if (!isEmpty(item)) {
        dataToShow = item
      }
    }

    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Dialog
        fullScreen
        open={dialogPolicy}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Policy' subTitle='Formulir Policy' />
            <div className="io-container mt-12">
              {!isEmpty(dataToShow) &&
                <IoteraForm
                  formData={dataToShow}
                  schema={schema()}
                  uiSchema={uiSchema}
                  onSubmit={_this.handleSubmit}
                  onChange={_this.handleChange}
                >
                  <div className="button-right">
                    <Button variant="outlined" type="button" size="large"
                      style={{ minWidth: '0%' }} onClick={handleClose} >Batal</Button>
                    <Button variant="contained" size="large" color="primary" type="submit"
                      style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                  </div>
                </IoteraForm>}
            </div>
          </div>
        </Loader>
      </Dialog>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    item: wSelector.getSoleInitMappedRPayload(state),
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Policy));